import { get } from "lodash"

export const searchStopWords = [
    // Deutsch
    "aber",
    "alle",
    "allem",
    "allen",
    "aller",
    "alles",
    "als",
    "also",
    "am",
    "an",
    "ander",
    "andere",
    "anderem",
    "anderen",
    "anderer",
    "anderes",
    "auch",
    "auf",
    "aus",
    "bei",
    "bin",
    "bis",
    "bist",
    "da",
    "damit",
    "dann",
    "der",
    "den",
    "des",
    "dem",
    "die",
    "das",
    "daß",
    "derselbe",
    "derselben",
    "denselben",
    "desselben",
    "demselben",
    "dieselbe",
    "dieselben",
    "dazu",
    "dir",
    "doch",
    "dort",
    "du",
    "durch",
    "ein",
    "eine",
    "einem",
    "einen",
    "einer",
    "eines",
    "er",
    "es",
    "etwas",
    "für",
    "gegen",
    "gewesen",
    "hab",
    "habe",
    "haben",
    "hat",
    "hatte",
    "hatten",
    "hier",
    "hin",
    "hinter",
    "ich",
    "ihr",
    "ihre",
    "ihres",
    "ihnen",
    "im",
    "in",
    "ist",
    "ja",
    "jede",
    "jedem",
    "jeden",
    "jeder",
    "jedes",
    "kein",
    "keine",
    "keinem",
    "keinen",
    "keiner",
    "keines",
    "können",
    "könnte",
    "machen",
    "man",
    "mehr",
    "mein",
    "meine",
    "mit",
    "muss",
    "musste",
    "nach",
    "nicht",
    "nichts",
    "noch",
    "nun",
    "nur",
    "ob",
    "oder",
    "ohne",
    "sehr",
    "sein",
    "seine",
    "seinem",
    "seinen",
    "seiner",
    "seines",
    "selbst",
    "sich",
    "sie",
    "sind",
    "so",
    "solche",
    "soll",
    "sollte",
    "sondern",
    "sonst",
    "um",
    "und",
    "uns",
    "unser",
    "unsere",
    "unter",
    "viel",
    "vom",
    "von",
    "vor",
    "war",
    "waren",
    "warst",
    "was",
    "weg",
    "weil",
    "weiter",
    "welche",
    "welchem",
    "welchen",
    "welcher",
    "welches",
    "wenn",
    "wer",
    "werde",
    "werden",
    "wie",
    "wieder",
    "will",
    "wir",
    "wird",
    "wirst",
    "wo",
    "wollen",
    "wollte",
    "wurde",
    "wurden",
    "zu",
    "zum",
    "zur",
    "zwar",
    "zwischen",

    // Englisch
    "a",
    "about",
    "above",
    "after",
    "again",
    "against",
    "all",
    "am",
    "an",
    "and",
    "any",
    "are",
    "aren't",
    "as",
    "at",
    "be",
    "because",
    "been",
    "before",
    "being",
    "below",
    "between",
    "both",
    "but",
    "by",
    "can",
    "can't",
    "cannot",
    "could",
    "couldn't",
    "did",
    "didn't",
    "do",
    "does",
    "doesn't",
    "doing",
    "don't",
    "down",
    "during",
    "each",
    "few",
    "for",
    "from",
    "further",
    "had",
    "hadn't",
    "has",
    "hasn't",
    "have",
    "haven't",
    "having",
    "he",
    "he'd",
    "he'll",
    "he's",
    "her",
    "here",
    "here's",
    "hers",
    "herself",
    "him",
    "himself",
    "his",
    "how",
    "how's",
    "i",
    "i'd",
    "i'll",
    "i'm",
    "i've",
    "if",
    "in",
    "into",
    "is",
    "isn't",
    "it",
    "it's",
    "its",
    "itself",
    "let's",
    "me",
    "more",
    "most",
    "mustn't",
    "my",
    "myself",
    "no",
    "nor",
    "not",
    "of",
    "off",
    "on",
    "once",
    "only",
    "or",
    "other",
    "ought",
    "our",
    "ours",
    "ourselves",
    "out",
    "over",
    "own",
    "same",
    "shan't",
    "she",
    "she'd",
    "she'll",
    "she's",
    "should",
    "shouldn't",
    "so",
    "some",
    "such",
    "than",
    "that",
    "that's",
    "the",
    "their",
    "theirs",
    "them",
    "themselves",
    "then",
    "there",
    "there's",
    "these",
    "they",
    "they'd",
    "they'll",
    "they're",
    "they've",
    "this",
    "those",
    "through",
    "to",
    "too",
    "under",
    "until",
    "up",
    "very",
    "was",
    "wasn't",
    "we",
    "we'd",
    "we'll",
    "we're",
    "we've",
    "were",
    "weren't",
    "what",
    "what's",
    "when",
    "when's",
    "where",
    "where's",
    "which",
    "while",
    "who",
    "who's",
    "whom",
    "why",
    "why's",
    "with",
    "won't",
    "would",
    "wouldn't",
    "you",
    "you'd",
    "you'll",
    "you're",
    "you've",
    "your",
    "yours",
    "yourself",
    "yourselves",
]

export const searchStopWordsSet = new Set(searchStopWords)

export const searchRegexFields = ["code", "name.de"]

export const searchRelevanceMap: Record<string, number> = {
    code: 1,
    "name.de": 0.8,
    "description.de": 0.6,
}

export function escapeRegExp(value: string) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
}

export function normalizeSearchValue(value: string) {
    return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
}

export function getSearchWords(input: string) {
    return getSearchWordsByPattern(input, /\s+/)
}

export function getSearchWordsByPattern(input: string, splitPattern: RegExp) {
    return input
        .split(splitPattern)
        .map((word) => word.trim())
        .filter((word) => word.length > 2)
        .filter((word) => !searchStopWordsSet.has(word.toLowerCase()))
}

export function buildProductSearchFilter(
    searchTerm: string,
    locale: string,
    regexTerms?: string[],
    regexFields: string[] = searchRegexFields
) {
    const trimmedSearchTerm = searchTerm?.trim()
    const filter: { $or: Record<string, any>[] } = { $or: [] }

    if (trimmedSearchTerm) {
        filter.$or.push({
            $text: {
                $search: trimmedSearchTerm,
                $language: locale,
            },
        })
    }

    const terms = (regexTerms?.length ? regexTerms : trimmedSearchTerm ? [trimmedSearchTerm] : [])
        .map((term) => term.trim())
        .filter(Boolean)

    terms.forEach((term) => {
        const escapedTerm = escapeRegExp(term)
        regexFields.forEach((field) => {
            filter.$or.push({
                [field]: {
                    $regex: escapedTerm,
                    $options: "i",
                },
            })
        })
    })

    return filter.$or.length ? filter : null
}

export function getMatchCount(value: string, word: string) {
    if (!value || !word) return 0
    return (value.match(new RegExp(escapeRegExp(word), "gi")) || []).length
}

export function scoreProductSearchMatch(
    product: Product,
    keywords: string[],
    options?: {
        articleNumber?: string
        relevanceMap?: Record<string, number>
    }
) {
    const relevanceMap = options?.relevanceMap || searchRelevanceMap
    const articleNumber = options?.articleNumber || ""
    let score = 0
    const productCode = product.code || ""

    if (articleNumber) {
        if (productCode === articleNumber) score += 1000
        else if (productCode.startsWith(articleNumber)) score += 500
        score += getMatchCount(productCode, articleNumber) * 50
    }

    Object.entries(relevanceMap).forEach(([field, relevance]) => {
        const fieldValue = String(get(product, field) ?? "")
        const normalizedFieldValue = normalizeSearchValue(fieldValue)

        keywords.forEach((keyword) => {
            const normalizedKeyword = normalizeSearchValue(keyword)
            score += getMatchCount(fieldValue, keyword) * relevance
            score += getMatchCount(normalizedFieldValue, normalizedKeyword) * relevance
        })
    })

    return score
}
